import React, { useState } from 'react';
// import theme from './ResidentialUnitImportPricingValueChangeModal.module.scss';
import { Modal, SimpleWizard, SimpleWizardStep } from '@ygtechnologies/bygr-frontend-component-library';
import { StepData } from './ResidentialUnitImport';
import ResidentialUnitEditPricingFieldsConfirm from '../ResidentialUnitEdit/ResidentialUnitEditPricingFieldsConfirm';
import ResidentialUnitEditPricingFieldsOrders from '../ResidentialUnitEdit/ResidentialUnitEditPricingFieldsOrders';
import ResidentialUnitEditTagsConfirm from '../ResidentialUnitEdit/ResidentialUnitEditTagsConfirm';
import ResidentialUnitTagsOrders from '../ResidentialUnitEdit/ResidentialUnitTagsOrders';

interface ResidentialUnitImportChangesModalProps {
    isOpen: boolean;
    data: StepData[];
    onSubmit(): void;
    onCancel(): void;
    getBuyerOptionGroupToUnlinkIds(unitId): number[] | null;
    onBuyerOptionGroupToUnlinkIdsChange(unitId: number, v: number[]): void;
}

const ResidentialUnitImportChangesModal: React.FC<ResidentialUnitImportChangesModalProps> = ({
    isOpen,
    data,
    onSubmit,
    onCancel,
    getBuyerOptionGroupToUnlinkIds,
    onBuyerOptionGroupToUnlinkIdsChange,
}) => {
    const [currentStep, setCurrentStep] = useState(0);
    const steps = data.map((x, i) => i);

    return (
        <Modal size="xl" isOpen={isOpen}>
            <SimpleWizard
                onCancel={onCancel}
                onSubmit={onSubmit}
                onStepChange={setCurrentStep}
                currentStep={currentStep}
                steps={steps}>
                {data.map((step, i) => (
                    <SimpleWizardStep key={i} header={step.residentialUnitName} stepNumber={i}>
                        {step.type === 'BuyerOption' && (
                            <ResidentialUnitEditPricingFieldsConfirm
                                optionGroups={step.data.buyerOptionsGroups}
                                changedPricingFields={step.data.changedPricingFields}
                            />
                        )}
                        {step.type === 'Order' && (
                            <ResidentialUnitEditPricingFieldsOrders
                                changedPricingFields={step.data.changedPricingFields}
                                orders={step.data.orders}
                            />
                        )}
                        {step.type === 'TagBuyerOption' && (
                            <>
                                <ResidentialUnitEditTagsConfirm
                                    residentialUnitName={step.residentialUnitName}
                                    optionGroups={step.data.buyerOptionsGroups}
                                    removedTags={step.data.removedTags}
                                    buyerOptionGroupToUnlinkIds={
                                        getBuyerOptionGroupToUnlinkIds(step.residentialUnitId) || []
                                    }
                                    onBuyerOptionGroupToUnlinkIdsChange={(ids) =>
                                        onBuyerOptionGroupToUnlinkIdsChange(step.residentialUnitId, ids)
                                    }
                                />
                            </>
                        )}
                        {step.type === 'TagOrder' && (
                            <ResidentialUnitTagsOrders
                                orders={step.data.orders.filter(
                                    (o) =>
                                        o.sourceOptionGroupId != null &&
                                        (getBuyerOptionGroupToUnlinkIds(step.residentialUnitId) || []).includes(
                                            o.sourceOptionGroupId
                                        )
                                )}
                            />
                        )}
                    </SimpleWizardStep>
                ))}
            </SimpleWizard>
        </Modal>
    );
};

export default ResidentialUnitImportChangesModal;
